module.exports = __webpack_public_path__ + "static/img/c2.3f8439d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/c2.png
// module id = qmcW
// module chunks = 0